module.exports = __webpack_public_path__ + "img/SHDeviceManage.547653cb.svg";